import { gql } from '@apollo/client';

// Powers the "Browse furniture objects" table on NewBlueprintSession.tsx —
// lets a user find an existing furniture draft_quote_object by customer/job/
// name instead of only reaching this form via the ?draftQuoteObjectId=...
// deep link from a Work Order. Selects the same field set as
// DRAFT_QUOTE_OBJECT_BY_ID_QUERY (draftQuotes.ts) so a picked row can be
// handed straight to applyDraftObjectPrefill() without a refetch.
//
// draft_quote_object has no direct FK to customer or job — the chain is
// draft_quote_object -> draft_quote -> job -> customer — and there's no
// connection-filter plugin installed, so `condition` only supports exact
// equality on real columns (itemType here). Customer/job filtering and name
// search both happen client-side in NewBlueprintSession.tsx against this
// bounded, newest-first batch.
export const FURNITURE_DRAFT_QUOTE_OBJECTS_QUERY = gql`
  query FurnitureDraftQuoteObjects {
    allDraftQuoteObjects(
      condition: { itemType: FURNITURE }
      orderBy: CREATED_AT_DESC
      first: 200
    ) {
      nodes {
        id
        name
        quantity
        itemType
        archivedAt
        createdAt
        furnitureType
        widthInches
        depthInches
        heightInches
        seatHeightInches
        seatDepthInches
        armHeightInches
        backHeightInches
        legHeightInches
        cushionThicknessInches
        armThicknessInches
        seatDeckThicknessInches
        backCushionThicknessInches
        legProfile
        fabricDescription
        workOrderLineItemsByDraftQuoteObjectId {
          nodes {
            workOrderByWorkOrderId {
              id
              travelerNumber
            }
          }
        }
        blueprintAiSessionsByDraftQuoteObjectId(orderBy: CREATED_AT_DESC) {
          nodes {
            id
            createdAt
            blueprintAiTurnsBySessionId(orderBy: INDEX_DESC, first: 5) {
              nodes {
                id
                returnJson
              }
            }
          }
        }
        draftQuoteByDraftQuoteId {
          id
          name
          jobByJobId {
            id
            name
            customerByCustomerId {
              id
              name
            }
          }
        }
      }
    }
  }
`;
